// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?v" + {"vendors-node_modules_dompurify_dist_purify_es_mjs":"db2950d59f49fe2593ab","vendors-node_modules_canvg_lib_index_es_js":"00a260db199a30fff951"}[chunkId] + "";
};